const MainModel = function (root, store) {
  return {
    id: null,
    rfqID: null,
    rfq3ID: null,
    rfqid: null,
    customerCompanyID: null,
    po: '',
    partID: null,
    partSN: null,
    reminderDate: null,
    priorityID: null,
    price: null,
    currencyID: null,
    conditionID: null,
    rfqTypeID: null,
    requestedDate: null,
    customerContactID: null,
    quoteDate: null,
    supplyDate: null,
    tagInfoCompanyID: null,
    tagDate: null,
    traceabilityCompanyID: null,
    remarks: null,
    exchangeCoreValue: null,
    exchangeCoreValueCurrencyID: null,
    exchangeConditionID: null,
    exchangeCoreReceived: null,
    coreDueDate: null,
    stockID: null,

    orderPhaseID: null,
    orderPhasePersonInChargeEmployeeID: null,
    lastInfo: '',
    dateInPhase: null,
    exchAgreementSigned: false,
    unitShipped: false,
    coreReceived: false,
    repairCostsApproved: false,
    unitReceivedCustomer: false,
    qty: 0,
    observation: ''
  }
}
const ModelEmailStatusRequest = function (root, state) {
  return {
    subject: null,
    po: null,
    partNumber: null,
    partSN: null,
    lastInfo: null
  }
}
const ModelEmailNewInstruction = function (root, state) {
  return {
    subject: null,
    po: null,
    partNumber: null,
    partSN: null,
    listActivities: null,
    lastInfo: null
  }
}
export {
  MainModel,
  // Emails
  ModelEmailStatusRequest,
  ModelEmailNewInstruction
}
